import Icon from '@ant-design/icons/lib/components/Icon'
import { Tabs } from 'antd'
import styled from 'styled-components'

export const AccountScreenContainer = styled.div`
  background: #f5f5f5;
  gap: 1%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1 1 0;
`

export const AccountScreenInnerContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-right: 25px;
`

export const AccountScreenInnerContainerTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  padding-bottom: 20px;
  & .iconButton {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & .anticon {
      margin-left: 0px;
    }
  }

  & .updateUserControlContainer {
    display: flex;
    gap: 10px;
  }
`

export const AccountScreenInnerContainerTitle = styled.h2`
  text-align: start;
  font-size: 1.3em;
  margin-bottom: 0px;
`

export const AccountScreenInnerContainerTitleLogo = styled(Icon)`
  padding: 0px 10px;
`

export const StyledDivider = styled.hr`
  height: 80%;
`

export const AccountTabs = styled(Tabs)`
  height: 100%;
  & .ant-tabs-content-holder {
    overflow-y: auto;
  }
`
